// Module
var code = `<template>
  <require from="./portfolio-overview-light-widget.scss"></require>
  <require from="../../../converters/column-widths-converter"></require>
  <require from="../../../converters/column-names-converter"></require>

  <div class="portfolio-overview-light-widget portfolio-overview-light-widget-\${id}">
    <!-- beautify ignore:start -->
    <style if.bind="rowHeight">
      .portfolio-overview-light-widget-\${id} tr {
        height: \${rowHeight}px !important;
      }
    </style>

    <style>
      .portfolio-overview-light-widget-\${id} td {
        font-family: \${font || 'var(--dyn-default-font-family)'};
        font-size: \${fontSize ? fontSize + 'px' : 'var(--dyn-default-font-size)'};
        color: \${color | widgetTemplateColor:isInDashboard} !important;
      }

      .portfolio-overview-light-widget-\${id} th {
        font-family: \${captionFont ? captionFont : 'var(--dyn-default-font-family)'};
        font-size: \${captionFontSize ? captionFontSize + 'px' : 'var(--dyn-default-font-size)'};
        color: \${captionColor | widgetTemplateColor:isInDashboard} !important;
      }
    </style>
    <!-- beautify ignore:end -->

    <mdc-circular-progress if.bind="loading"></mdc-circular-progress>
    <table if.bind="!loading && !error" class="widget-table">
      <thead>
        <tr>
          <th style="\${columnWidths | columnWidths:0}">\${columnNames | columnNames:0}</th>

          <th style="\${columnWidths | columnWidths:1}" class="widget-table__numeric">\${columnNames | columnNames:1}</th>

          <th style="\${columnWidths | columnWidths:2}" class="widget-table__numeric">\${columnNames | columnNames:2}</th>

          <th style="\${columnWidths | columnWidths:3}" class="portfolio-overview-light-widget__currency">\${columnNames | columnNames:3}</th>

          <th style="\${columnWidths | columnWidths:4}" class="widget-table__numeric">\${columnNames | columnNames:4}</th>

          <th if.bind="displayFifo" style="\${columnWidths | columnWidths:5}" class="widget-table__numeric">
            \${columnNames | columnNames:5}</th>
          <th if.bind="displayAvg" style="\${columnWidths | columnWidths:5}" class="widget-table__numeric">
            \${columnNames | columnNames:5} (AVG)</th>

          <th if.bind="displayFifo" style="\${columnWidths | columnWidths:6}" class="widget-table__numeric">
            \${columnNames | columnNames:6}</th>
          <th if.bind="displayAvg" style="\${columnWidths | columnWidths:6}" class="widget-table__numeric">
            \${columnNames | columnNames:6} (AVG)</th>

          <th style="\${columnWidths | columnWidths:7}" class="widget-table__numeric">
            \${columnNames | columnNames:7}</th>

          <th if.bind="displayFifo" style="\${columnWidths | columnWidths:8}" class="widget-table__numeric">
            \${columnNames | columnNames:8}</th>
          <th if.bind="displayAvg" style="\${columnWidths | columnWidths:8}" class="widget-table__numeric">
            \${columnNames | columnNames:8} (AVG)</th>

          <th style="\${columnWidths | columnWidths:9}" class="widget-table__numeric">
            \${columnNames | columnNames:9}</th>

          <th style="\${columnWidths | columnWidths:10}" class="widget-table__numeric">
            \${columnNames | columnNames:10}</th>

          <th if.bind="displayFifo" style="\${columnWidths | columnWidths:11}" class="widget-table__numeric">
            \${columnNames | columnNames:11}</th>
          <th if.bind="displayAvg" style="\${columnWidths | columnWidths:11}" class="widget-table__numeric">
            \${columnNames | columnNames:11} (AVG)</th>

          <th if.bind="displayFifo" style="\${columnWidths | columnWidths:12}" class="widget-table__numeric">
            \${columnNames | columnNames:12}</th>
          <th if.bind="displayAvg" style="\${columnWidths | columnWidths:12}" class="widget-table__numeric">
            \${columnNames | columnNames:12} (AVG)</th>

          <th style="\${columnWidths | columnWidths:13}" class="widget-table__numeric">
            \${columnNames | columnNames:13}</th>
        </tr>
      </thead>
      <tbody>
        <template repeat.for="v of instrumentValues">
          <tr class="\${v === total ? 'widget-table__total' : ''} \${v.group1Total ? 'widget-table__group-total' : ''} \${v.group1Header ? 'widget-table__group-header' : ''}">
            <td style="\${columnWidths | columnWidths:0}; padding-left: \${v.indent}px">
              \${v.name}</td>

            <template if.bind="!groupHeader">
              <td style="\${columnWidths | columnWidths:1}" class="widget-table__numeric">
                \${v.quantityClosingBalance | numericFormatter:quantityPrecision}
              </td>

              <td style="\${columnWidths | columnWidths:2}" class="widget-table__numeric">
                \${v.sellPrice | numericFormatter:precision}
              </td>

              <td style="\${columnWidths | columnWidths:3}" class="portfolio-overview-light-widget__currency">\${v.sellPriceCcy}</td>

              <td style="\${columnWidths | columnWidths:4}" class="widget-table__numeric">
                \${v.estimatedValueClosingBalance | numericFormatter:precision}
              </td>

              <td if.bind="displayFifo" style="\${columnWidths | columnWidths:5}" class="widget-table__numeric">
                \${v.costPriceClosingBalance | numericFormatter:precision}</td>
              <td if.bind="displayAvg" style="\${columnWidths | columnWidths:5}" class="widget-table__numeric">
                \${v.avgCostPriceClosingBalance | numericFormatter:precision}</td>

              <td if.bind="displayFifo" style="\${columnWidths | columnWidths:6}" class="widget-table__numeric">
                \${v.unrealizedProfitLossChangeInPeriod | numericFormatter:precision}</td>
              <td if.bind="displayAvg" style="\${columnWidths | columnWidths:6}" class="widget-table__numeric">
                \${v.avgUnrealizedProfitLossChangeInPeriod | numericFormatter:precision}</td>

              <td if.bind="displayFifo" style="\${columnWidths | columnWidths:7}" class="widget-table__numeric">
                \${v.unrealizedProfitLossChangeInPeriod / v.costPriceClosingBalance * 100 | numericFormatter:0}</td>
              <td if.bind="displayAvg" style="\${columnWidths | columnWidths:7}" class="widget-table__numeric">
                \${v.avgUnrealizedProfitLossChangeInPeriod / v.avgCostPriceClosingBalance * 100 | numericFormatter:0}
              </td>

              <td if.bind="displayFifo" style="\${columnWidths | columnWidths:8}" class="widget-table__numeric">
                \${v.realizedProfitLossChangeInPeriod | numericFormatter:precision}</td>
              <td if.bind="displayAvg" style="\${columnWidths | columnWidths:8}" class="widget-table__numeric">
                \${v.avgRealizedProfitLossChangeInPeriod | numericFormatter:precision}</td>

              <td style="\${columnWidths | columnWidths:9}" class="widget-table__numeric">
                \${v.dividendChangeInPeriod | numericFormatter:precision}
                <promise-resolver resolve.bind="lastItemRendered" if.bind="\$last"></promise-resolver>
              </td>

              <td style="\${columnWidths | columnWidths:10}" class="widget-table__numeric">
                \${v.interestChangeInPeriod | numericFormatter:precision}</td>

              <td if.bind="displayFifo" style="\${columnWidths | columnWidths:11}" class="widget-table__numeric">
                \${v.profitLossChangeInPeriod | numericFormatter:precision}</td>
              <td if.bind="displayAvg" style="\${columnWidths | columnWidths:11}" class="widget-table__numeric">
                \${v.avgProfitLossChangeInPeriod | numericFormatter:precision}</td>

              <td if.bind="displayFifo" style="\${columnWidths | columnWidths:12}" class="widget-table__numeric">
                \${v.unrealizedProfitLossClosingBalance | numericFormatter:precision}</td>
              <td if.bind="displayAvg" style="\${columnWidths | columnWidths:12}" class="widget-table__numeric">
                \${v.avgUnrealizedProfitLossClosingBalance | numericFormatter:precision}</td>

              <td if.bind="displayFifo" style="\${columnWidths | columnWidths:13}" class="widget-table__numeric">
                \${v.unrealizedProfitLossClosingBalance / v.costPriceClosingBalance * 100 | numericFormatter:0}</td>
              <td if.bind="displayAvg" style="\${columnWidths | columnWidths:13}" class="widget-table__numeric">
                \${v.avgUnrealizedProfitLossClosingBalance / v.avgCostPriceClosingBalance * 100 | numericFormatter:0}
              </td>

            </template>
          </tr>
        </template>
      </tbody>
    </table>

    <message if.bind="error" class="widget__error" icon="error" colour="mdc-theme--error">
      \${error.message}
    </message>
  </div>
</template>
`;
// Exports
export default code;